import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class ClientConfigServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getConfig(params = {}) {
    return this.http.get('/current', { params: params });
  }
  updateConfig(params = {}) {
    return this.http.put('/update', params);
  }
}

export const ClientConfigService = new ClientConfigServiceClass({
  api_version: 2,
  resource: 'pbx/client-configs'
});
